import {SchemasOrderPaymentMethodManagement} from '@shared/schemas/order'

import {PaymentMethodManagementEntryValues} from '@web/core/constants'
import getApi from '@web/helpers/api'

import {RegistPaymentMethodsParams} from './interfaces'

const api = getApi(`/orderApi`)

const paymentMethodApiUrl = '/orderSheet/paymentMethodManagement'

/**
 * 결제수단 조회
 */
export const fetchPaymentMethodInfo = async ({
    entry,
}: {
    entry: PaymentMethodManagementEntryValues
}): Promise<SchemasOrderPaymentMethodManagement['/info']['response']> => {
    const {
        data: {result},
    } = await api.get(`${paymentMethodApiUrl}/info`, {params: {entry}})

    return result
}

/**
 * 결제수단 등록
 */
const registerPaymentMethod = async (
    requestParams: RegistPaymentMethodsParams,
): Promise<SchemasOrderPaymentMethodManagement['/register']['response']> => {
    const {data} = await api.post(`${paymentMethodApiUrl}/register`, requestParams)

    return data
}

/**
 * 결제수단 업데이트
 */
const updatePaymentMethod = async (
    requestParams: RegistPaymentMethodsParams,
): Promise<SchemasOrderPaymentMethodManagement['/update']['response']> => {
    const {data} = await api.put(`${paymentMethodApiUrl}/update`, requestParams)

    return data
}

export default {
    fetchPaymentMethodInfo,
    registerPaymentMethod,
    updatePaymentMethod,
}
